/**
 * Feature-specific query keys for projects
 * Co-located with the project feature for better organization
 */

export const projectQueryKeys = {
  all: ["projects"] as const,
  list: (params: {
    page?: number;
    size?: number;
    sort?: string[];
  }) => ["projects", "list", params] as const,
  withAssociations: (params: {
    page?: number;
    size?: number;
    sort?: string[];
  }) => ["projects", "withAssociations", params] as const,
  byFieldOfWork: (params: {
    fieldOfWorkId?: string;
    page?: number;
    size?: number;
    sort?: string[];
  }) => ["projects", "byFieldOfWork", params] as const,
  search: (params: {
    searchTerm?: string;
    fieldOfWorkId?: string | null;
    page?: number;
    size?: number;
  }) => ["projects", "search", params] as const,
  detail: (id: string) => ["projects", "detail", id] as const,
  detailBySlug: (slug: string) => ["projects", "detailBySlug", slug] as const,
  supporters: (id: string, params?: {
    page?: number;
    size?: number;
  }) => ["projects", id, "supporters", params] as const,
  statistics: (id: string) => ["projects", id, "statistics"] as const,
  transactions: (id: string, params?: {
    page?: number;
    size?: number;
  }) => ["projects", id, "transactions", params] as const,
  related: (id: string) => ["projects", id, "related"] as const,
} as const;